import { useState } from "react";
import { useNavigate } from "react-router-dom";
import TourDefinitionFormFirstStep from "./TourDefinitionFormFirstStep";

const TourDefinitionStepper = () => {
  const [stepTab, setStepTab] = useState(0);
  const navigate = useNavigate();
  const [stepFlag, setStepFlag] = useState(false);

  const nextStepFlag = (flag) => {
    setStepFlag(flag);
  };
  const nextStepHandler = (id, step) => {
    navigate({
      pathname: `/manageTours/${id}`,
      search: `?step=${step}`,
    });
  };

  const formRenderHandler = () => {
    switch (stepTab) {
      case 0: {
        return (
          <TourDefinitionFormFirstStep
            nextStepHandler={nextStepHandler}
            nextStepFlag={nextStepFlag}
            stepFlag={stepFlag}
          />
        );
      }
      case 1: {
        return <div>step 2</div>;
      }
      case 2: {
        return <div>step 3</div>;
      }
      case 3: {
        return <div>step 4</div>;
      }
      case 4: {
        return <div>step 5</div>;
      }
      default: {
        return;
      }
    }
  };
  return (
    <div className="p-5">
      <div className="md:mx-4 py-4 md:p-4">
        <div className="flex items-center">
          <div
            className={`flex items-center relative cursor-pointer ${
              stepTab === 0
                ? "text-white"
                : stepTab > 0
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            onClick={() => setStepTab(0)}
          >
            <div
              className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 0
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 0
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 0
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              تعریف تور
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
              stepTab > 0 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-not-allowed ${
              stepTab === 1
                ? "text-white"
                : stepTab > 1
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            // onClick={() => setStepTab(1)}
          >
            <div
              className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 1
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 1
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 1
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              اطلاعات تور
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
              stepTab > 1 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-not-allowed ${
              stepTab === 2
                ? "text-white"
                : stepTab > 2
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            // onClick={() => setStepTab(2)}
          >
            <div
              className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 2
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 2
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 2
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              قیمت و تاریخ برگزاری
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
              stepTab > 2 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-not-allowed ${
              stepTab === 3
                ? "text-white"
                : stepTab > 3
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            // onClick={() => setStepTab(3)}
          >
            <div
              className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 3
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 3
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 3
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              برنامه زمانی سفر
            </div>
          </div>
          <div
            className={`flex-auto border-t-2 transition duration-500 ease-in-out ${
              stepTab > 3 ? "border-darkGreenKite" : "border-gray-300"
            }`}
          ></div>
          <div
            className={`flex items-center relative cursor-not-allowed ${
              stepTab === 4
                ? "text-white"
                : stepTab > 4
                ? "text-darkGreenKite"
                : "text-gray-500"
            }`}
            // onClick={() => setStepTab(4)}
          >
            <div
              className={`rounded-full transition duration-500 ease-in-out h-12 w-12 py-3 border-2 ${
                stepTab === 4
                  ? "border-darkGreenKite bg-darkGreenKite"
                  : stepTab > 4
                  ? "border-darkGreenKite bg-white"
                  : "border-gray-300"
              }`}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-bookmark "
              >
                <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
            <div
              className={`absolute top-0 -mr-10 text-center mt-16 w-32 text-xs font-medium uppercase ${
                stepTab === 4
                  ? "inline-block text-darkGreenKite font-semibold"
                  : "text-gray-500 hidden md:inline-block"
              }`}
            >
              خدمات تور
            </div>
          </div>
        </div>
      </div>
      <div className="mt-8 py-4 md:p-4">{formRenderHandler()}</div>
    </div>
  );
};

export default TourDefinitionStepper;
